import { render, staticRenderFns } from "./ForeignStockOrders.vue?vue&type=template&id=d1b9a1e0&scoped=true"
import script from "./ForeignStockOrders.vue?vue&type=script&lang=js"
export * from "./ForeignStockOrders.vue?vue&type=script&lang=js"
import style0 from "./ForeignStockOrders.vue?vue&type=style&index=0&id=d1b9a1e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1b9a1e0",
  null
  
)

export default component.exports